export default __webpack_public_path__ + "static/media/ferven.67b6e962.png";